import { render } from "./Tetris.vue?vue&type=template&id=7d19f7e8"
import script from "./Tetris.vue?vue&type=script&lang=js"
export * from "./Tetris.vue?vue&type=script&lang=js"

import "./Tetris.vue?vue&type=style&index=0&id=7d19f7e8&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__